import axios from 'axios';
import React from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Table
} from 'reactstrap';
import { EditPermissionsModal } from './Modals';
import { environment } from '../../../environment/environment';
import './UserPermissions.css';

class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userLookup: {},
      orderedPermissions: [],
      userPermissionMaps: {},
      loading: false,
      showEditModal: false,
      selectedUser: null,
    };
  }

  componentDidMount() {
    this.getPermissionData();
  }


  calculateUserPermissionMaps = (userLookup) => {
    const users = Object.values(userLookup);
    const userPermissionMaps = {};

    users.forEach(user => {
      userPermissionMaps[user.id] = {};
      const permissions = user.user_permissions || [];
      permissions.forEach(perm => {
        userPermissionMaps[user.id][perm.id] = perm;
      });
    });

    return userPermissionMaps;
  };

  getPermissionData = () => {
    this.setState({ loading: true });

    axios.get(`${environment.baseUrl}/permissions/`)
      .then((res) => {
        const userLookup = {};
        const allPermissions = new Map();

        res.data.forEach(user => {
          userLookup[user.id] = user;

          // Collect all unique permissions
          user.user_permissions?.forEach(perm => {
            if (!allPermissions.has(perm.id)) {
              allPermissions.set(perm.id, perm);
            }
          });
        });

        const orderedPermissions = Array.from(allPermissions.values());
        const userPermissionMaps = this.calculateUserPermissionMaps(userLookup);

        this.setState({ userLookup, orderedPermissions, userPermissionMaps, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching permission data:', error);
        this.setState({ loading: false });
      });
  };


  openEditModal = (user) => {
    this.setState({
      showEditModal: true,
      selectedUser: user,
    });
  };

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedUser: null,
    });
  };

  handleSavePermissions = (updatedUser) => {
    this.setState(prevState => {
      const updatedUserLookup = {
        ...prevState.userLookup,
        [updatedUser.id]: updatedUser
      };
      return {
        userLookup: updatedUserLookup,
        userPermissionMaps: this.calculateUserPermissionMaps(updatedUserLookup)
      };
    });
  };


  render() {
    const { userLookup, orderedPermissions, userPermissionMaps, loading, showEditModal, selectedUser } = this.state;
    const users = Object.values(userLookup);

    return (
      <>
        <div className="header bg-primary pb-6">
          <Container fluid>
            <div className="header-body">
              <Row className="align-items-center py-4">
                <Col lg="6">
                  <h6 className="h2 text-white d-inline-block mb-0">
                    User permissions
                  </h6>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container className="mt--7" fluid>
          <Row>
            <div className="col-12 mt-3">
              <Card className="shadow">
                {loading ? (
                  <Row className="my-3">
                    <Col className="d-flex justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="table-container permissions-table-container">
                    <Table
                      className="table align-items-center table-flush table-bordered"
                      responsive>
                      <thead className="permissions-table-header-sticky">
                        <tr>
                          <th scope="col" className="name-column">Name</th>
                          <th scope="col" className="text-center">Actions</th>
                          {orderedPermissions.map((perm) => (
                            <th key={perm.id} className="text-center" scope="col">
                              {perm.name}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {users?.map((user) => {
                            const fullName = `${user.first_name} ${user.last_name}`;
                            return (
                              <tr key={user.id}>
                                <td className="name-column">
                                  <span className="permissions-name-text">
                                    {fullName}
                                  </span>
                                </td>

                                <td className="text-center">
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => this.openEditModal(user)}
                                  >
                                    <i className="fas fa-edit" /> Edit
                                  </Button>
                                </td>
                                {orderedPermissions.map((headerPerm) => {
                                  const userPerm = userPermissionMaps[user.id][headerPerm.id];
                                  return (
                                    <td key={headerPerm.id} className="text-center">
                                      {userPerm?.active ? (
                                        <i className="fas fa-check-circle text-lg text-success" />
                                      ) : (
                                        <i className="fas fa-times-circle text-lg text-warning" />
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Card>
            </div>
          </Row>
        </Container>

        <EditPermissionsModal
          isOpen={showEditModal}
          onClose={this.closeEditModal}
          user={selectedUser}
          onSave={this.handleSavePermissions}
        />
      </>
    );
  }
}

export default UserList;
